import { Route } from '@angular/router';
import { AuthComponent } from './modules/auth/auth/auth.component';
import { DynamicLoginComponent } from './modules/auth/auth-content/dynamic-login/dynamic-login.component';
import { ForgotPasswordComponent } from './modules/auth/auth-content/forgot-password/forgot-password.component';
import { LoginComponent } from './modules/auth/auth-content/login/login.component';
import { ResetPasswordComponent } from './modules/auth/auth-content/reset-password/reset-password.component';
import { forgotPasswordFields } from './routes-fields/forgot-password';
import { resetPasswordFields } from './routes-fields/reset-password';
import { SSOFields } from './routes-fields/sso-fields';
import {
  threeFieldsEnvision,
  threeFields,
  threeFieldsAesthetic,
  threeFieldsMinbody,
} from './routes-fields/three-fields';
import { twoFields } from './routes-fields/two-fields';
const RxIEActivateGuard = () => import('@nrwl/rx-ie-detection').then((m) => m.RxIEActivateGuard);

//export const appRoutes: Route[] = [];

export const appRoutes: Route[] = [
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      {
        path: 'login',
        component: LoginComponent,
        data: { title: 'login' },
        canActivate: [RxIEActivateGuard],
        children: [
          {
            path: '',
            component: DynamicLoginComponent,
            data: { title: '', formFields: twoFields },
          },
          {
            path: 'envisionnow',
            component: DynamicLoginComponent,
            data: {
              title: 'EnvisionNow',
              formFields: threeFieldsEnvision,
            },
          },
          {
            path: 'patientnow-essentials',
            component: DynamicLoginComponent,
            data: {
              title: 'PatientNow: Essentials',
              formFields: threeFieldsEnvision,
            },
          },
          {
            path: 'patientnow-pro',
            component: DynamicLoginComponent,
            data: {
              title: 'PatientNow: Pro',
              formFields: threeFields,
            },
          },
          {
            path: 'spc',
            component: DynamicLoginComponent,
            data: {
              title: 'Social Patient Center',
              formFields: threeFieldsAesthetic,
            },
          },
          {
            path: 'athenahealth',
            component: DynamicLoginComponent,
            data: { title: 'Athena Health', formFields: twoFields },
          },
          {
            path: 'drchrono',
            component: DynamicLoginComponent,
            data: { title: 'Dr Chrono', formFields: twoFields },
          },
          {
            path: 'greenway',
            component: DynamicLoginComponent,
            data: { title: 'Greenway', formFields: twoFields },
          },
          {
            path: 'intergy',
            component: DynamicLoginComponent,
            data: { title: 'Intergy', formFields: twoFields },
          },
          {
            path: 'mindbody',
            component: DynamicLoginComponent,
            data: {
              title: 'Mindbody',
              formFields: threeFieldsMinbody,
            },
          },
          {
            path: 'modmed',
            component: DynamicLoginComponent,
            data: {
              title: 'Modernizing Medicine',
              formFields: twoFields,
            },
          },
          {
            path: 'nextech',
            component: DynamicLoginComponent,
            data: { title: 'Nextech', formFields: twoFields },
          },
          {
            path: 'streamline',
            component: DynamicLoginComponent,
            data: {
              title: 'Streamline MD',
              formFields: threeFields,
            },
          },
          {
            path: 'intakeq',
            component: DynamicLoginComponent,
            data: { title: 'IntakeQ', formFields: twoFields },
          },
          {
            path: 'sso',
            component: DynamicLoginComponent,
            data: { formFields: SSOFields },
          },
        ],
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        data: { title: 'Forgot Password' },
        children: [
          {
            path: '',
            component: DynamicLoginComponent,
            data: {
              title: 'Forgot Password',
              formFields: forgotPasswordFields,
            },
          },
        ],
      },
      {
        path: 'reset-password/:id',
        component: ResetPasswordComponent,
        data: { title: 'Reset Password' },
        children: [
          {
            path: ':token',
            component: DynamicLoginComponent,
            data: {
              title: 'Reset Password',
              formFields: resetPasswordFields,
            },
          },
        ],
      },
      {
        path: 'browser-notification',
        loadChildren: () => import('@nrwl/rx-ie-detection').then((m) => m.RxIEDetectionModule),
      },
      // { path: '**', redirectTo: 'login' },
    ],
  },
];
